import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.ends-with.js";
// --- SocketIO
import { getToken, getUserID } from '@/utils/auth';
import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import io from 'socket.io-client';
import store from '@/store';
import capacitor from '@/../capacitor.config.json';
import * as screenInfo from '@/utils/screen';
import { getDevid } from '@/utils/various';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { getLocation } from '@/utils/location-helper';
var socketIO_initialized = false;
var con;
var connected = false;
export var con;
export function isConnected() {
  return connected;
}
export function initSocketIO() {
  return _initSocketIO.apply(this, arguments);
}

// -- Global subscribe / unsubscribe
function _initSocketIO() {
  _initSocketIO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var url, query, token, id, devid, info, options;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (socketIO_initialized) {
            _context.next = 21;
            break;
          }
          // Problems with subpath:
          // See URL parsing: https://stackoverflow.com/a/31415172/5331765
          url = new URL(process.env.VUE_APP_BASE_API);
          query = {};
          token = getToken();
          id = getUserID();
          _context.next = 7;
          return getDevid();
        case 7:
          devid = _context.sent;
          _context.next = 10;
          return Device.getInfo();
        case 10:
          info = _context.sent;
          // -- set fields only if they exist. If null or undefined is passed server will receive 'null'/'undefined' as string
          if (info) {
            query = {
              'os': info.platform,
              'package_name': capacitor.appId,
              'version': capacitor.appVersion,
              // query.version = await App.getInfo().version  // no web implementation => Workaround: set attribute in capacitor.config.json
              'manufacturer': info.manufacturer,
              'model': info.model,
              'os_version': info.osVersion
            };
          }
          if (token) query.token = token;
          if (id) query.id = id;
          if (devid) query.devid = devid;
          options = {
            path: url.pathname + (url.pathname.endsWith('/') ? '' : '/') + 'socket.io/',
            query: query,
            secure: true,
            reconnection: true,
            rejectUnauthorized: false,
            transports: ['websocket', 'polling']
          }; // Vue.use(VueSocketIO, io('http://' + url.host, options), { store }) // doesn't work with SSL
          con = new VueSocketIO({
            connection: io(url.protocol + '//' + url.host, options)
          });
          con.io.on('connect', function () {
            connected = true;

            // --- Report screen size, orientation and approx location on every reconnect
            con.io.emit('configChanged', {
              orientation: screenInfo.getOrientation(),
              screenSize: screenInfo.getScreenSize()
            });
            getLocation({
              enableHighAccuracy: false
            }).then(function (location) {
              con.io.emit('configChanged', {
                location: {
                  lat: location.coords.latitude,
                  lng: location.coords.longitude
                },
                screenSize: screenInfo.getScreenSize()
              });
            }).catch(function (e) {});
            // ---
          });

          con.io.on('disconnect', function () {
            connected = false;
          });
          Vue.use(con, {
            store: store
          }); // Works with and without SSL and also with FILE
          socketIO_initialized = true;
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _initSocketIO.apply(this, arguments);
}
var global_component = {
  $options: {
    name: 'Global'
  }
}; // To prevent Nullpointer

export function subscribe(event, callback) {
  con.emitter.addListener(event, callback, global_component);
}
export function unsubscribe(event) {
  con.emitter.removeListener(event, global_component);
}
export function destroySocketIO() {
  if (socketIO_initialized) {
    // disconnect SocketIO
    if (con && con.io && con.io.close) con.io.close();
    socketIO_initialized = false;
  }
}
export function connect() {
  if (con && con.io) con.io.connect();
}
export function disconnect() {
  if (con && con.io) con.io.disconnect();
}
// ---

var active = false;
if (App) {
  App.addListener("appStateChange", function (e) {
    // console.log(e.isActive)
    // console.log(con.io.connected)
    active = e.isActive;
    if (con && con.io) {
      if (!e.isActive) {
        con.io.disconnect();
      } else {
        setTimeout(function () {
          // Delay reconnect to make sure disconnect is called first when switching tab
          if (active) con.io.connect();
        }, 1000);
      }
    }
  });
}